import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import axios from 'axios';
import { baseurl } from '../url';

const HomePage = () => {
  const navigate = useNavigate();
  const [isApproved, setIsApproved] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.documentElement.classList.add('homepage');
    document.body.classList.add('homepage');

    const checkApprovalStatus = async () => {
      try {
        const response = await axios.get(`${baseurl}/api/status`);
        setIsApproved(response.data.isApproved);
      } catch (error) {
        console.error('Error fetching approval status:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkApprovalStatus();

    return () => {
      document.documentElement.classList.remove('homepage');
      document.body.classList.remove('homepage');
    };
  }, []);

  const handleSelection = (event) => {
    const selectedUser = event.target.value;
    if (!selectedUser) return;

    const routes = {
      student: '/studentlogin',
      officer: '/officerlogin',
      faculty: '/facultylogin',
      classTutor: '/classtutorlogin',
      hod: '/hodlogin',
      principal: '/principallogin',
      admin: '/adminlogin'
    };

    if (routes[selectedUser]) {
      navigate(routes[selectedUser]);
    }

    event.target.value = '';
  };

  const handleAdmission = () => {
    navigate('/admission');
  };

  if (isLoading) {
    return (
      <div className="office-home-page">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="office-home-page">
      <h1 className="animate-left">Welcome to CAP</h1>
      <h5 className="animate-right">Your Personal Assistant for College</h5>
      <h6>Select Your Role</h6>
      
      <div className="dropdown-container">
        <select onChange={handleSelection} defaultValue="">
          <option value="" disabled>Select User Type</option>
          <option value="student">Student</option>
          <option value="officer">Officer</option>
          <option value="faculty">Faculty</option>
          <option value="classTutor">Class Tutor</option>
          <option value="hod">HOD</option>
          <option value="principal">Principal</option>
          <option value="admin">Administrator</option>
        </select>
      </div>
      
      {isApproved && (
        <button className="admission-button" onClick={handleAdmission}>
          Application Form
        </button>
      )}
    </div>
  );
};

export default HomePage;